import { HttpErrorResponse, HttpRequest } from "@angular/common/http";

export class PgHelpTicket {
    url:string = null;
    email:string = null;
    type?:string = null;
    message?:string = null;
    info?:any = null;
    httpErrorLog?:Array<PgHelpHttpError> = null;
    jsErrorLog?:Array<PgHelpJsError> = null;
}

export class PgHelpHttpError {
    time:string
    request:HttpRequest<any>
    response:HttpErrorResponse
}

export class PgHelpJsError {
    time:string
    error:any
}